export function isPreCalcFlagOn(value) {
  return value === true || value === "true";
}

export function isPreCalcFlagOff(value) {
  return value === false || value === "false";
}

export function sanitizePreCalcPartTzinunFlags(part) {
  if (!part) return part;
  const isGift = part.wayOfGettingProperty === "gift";
  if (!isPreCalcFlagOn(part.isSinglePropertyPtorAllowed) || !isGift) {
    part.hasTzinunOnPtor = false;
  }
  if (!isPreCalcFlagOn(part.isMutavAllowed) || !isGift) {
    part.hasMutavTzinun = false;
  }
  return part;
}

export function sanitizePreCalcTzinunFlags(preCalc) {
  if (!preCalc || !Array.isArray(preCalc.preCalcPartsData)) return preCalc;
  preCalc.preCalcPartsData.forEach(sanitizePreCalcPartTzinunFlags);
  return preCalc;
}
